import useSWR, { SWRConfiguration } from 'swr';
import { MandantTaxConflict } from '../types';

export const mandantConflictsKey = (clubSlug?: string | null) =>
    clubSlug ? `invoice/${clubSlug}/mandant/conflicts` : null;

export const useMandantConflicts = (clubSlug?: string | null, config: SWRConfiguration = {}) => {
    const { data, ...rest } = useSWR<{ data: MandantTaxConflict[] }>(mandantConflictsKey(clubSlug), null, config);

    return { ...rest, conflicts: data?.data ?? [] };
};
